import { Outlet } from 'react-router-dom';
import { styled } from '@material-ui/core/styles';
import MainNavbar from './MainNavbar';
import { Box } from '@material-ui/core';

const MainLayoutRoot = styled('div')(
  ({ theme }) => ({
    backgroundColor: theme.palette.background.paper,
    display: 'flex',
    height: '100%',
    overflow: 'hidden',
    width: '100%',
    fontFamily: 'Roboto Flex',
  })
);

const MainLayoutWrapper = styled('div')({
  display: 'flex',
  flex: '1 1 auto',
  overflow: 'hidden',
  background: '#FAF8F6',
  paddingTop: 70
});

const MainLayoutContainer = styled('div')({
  display: 'flex',
  flex: '1 1 auto',
  overflow: 'hidden',
});

const MainLayoutContent = styled('div')({
  flex: '1 1 auto',
  height: '100%',
  overflow: 'hidden'
});

const MainLayout = ( {children} ) => {

  return (
    <MainLayoutRoot>
      <MainNavbar />
      <MainLayoutWrapper>
        <MainLayoutContainer>
          <MainLayoutContent>
            <Box sx={{
              maxWidth:"500px",
              position:"absolute",
              bottom:0,
              left: "50%",
              transform: "translateX(-50%)",
              zIndex:0,
            }}>
              <img
                src="/static/mainLayout-bg.png"
                width="100%"
              />
            </Box>
            {children}

          </MainLayoutContent>
        </MainLayoutContainer>
      </MainLayoutWrapper>
    </MainLayoutRoot>
  )
}

export default MainLayout;
